import {Box} from '@mui/material';
import {Outlet, useLocation} from 'react-router-dom';
import TabMenu from 'src/components/TabMenu';
import SensorDoorOutlinedIcon from '@mui/icons-material/SensorDoorOutlined';
import {useMemo} from 'react';
import PhoneIcon from '@mui/icons-material/Phone';

export default function EventSearchLayout() {
  const location = useLocation();
  const tabs = useMemo(() => {
    return [
      {to: '/eventSearch', label: 'Call Event', icon: <PhoneIcon />},
      {to: '/eventSearch/doorEvent', label: 'Door Event', icon: <SensorDoorOutlinedIcon />},
    ];
  }, []);
  const showTab = tabs.some(tab => tab.to === location.pathname);

  return (
    <>
      {showTab && <TabMenu tabs={tabs} />}
      <Box sx={{paddingY: 2}}>
        <Outlet />
      </Box>
    </>
  );
}
